<nav id="footer-container" aria-label="footer-container">
    <mat-toolbar color="primary">
        <nav class="footer-menu" aria-label="footer-menu" *ngIf="onLocationContextScreen() === false">
            <div class="footer-menu-items">
                <div class="footer-menu-item" *ngFor="let item of mainMenuItems">
                    <a routerLink="{{ item.router }}">
                        <mat-icon>{{ item.icon }}</mat-icon>
                        <span>{{ item.text }}</span>
                    </a>
                </div>
            </div>
        </nav>
    </mat-toolbar>
</nav>
